import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';

/**
 * Default Class Component
 */
@Component({
	selector: 'app-duration-selector',
	templateUrl: './duration-selector.component.html',
	styleUrls: ['./duration-selector.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class DurationSelectorComponent implements OnInit, OnChanges {

	/** Dutarion */
	@Input() duration: string = "01:00:00";

	/** Optional: Custom duration chips */
	@Input() chipDurations?: {
		time: string;
		text: string;
		toolTip: string;
		default?: boolean;
	}[] = [];

	/** Duration Change Event */
	@Output() durationChange = new EventEmitter<string>();

	/** Default durations */
	private defaultDurations = [
		{ time: "00:08:00", text: "8h", toolTip: "8 Hours" },
		{ time: "00:12:00", text: "12h", toolTip: "12 Hours" },
		{ time: "01:00:00", text: "1d", toolTip: "1 Day" },
		{ time: "02:00:00", text: "2d", toolTip: "2 Days" },
		{ time: "07:00:00", text: "7d", toolTip: "7 Days" },
		{ time: "30:00:00", text: "30d", toolTip: "30 Days" },
		{ time: "60:00:00", text: "60d", toolTip: "60 Days" },
		{ time: "90:00:00", text: "90d", toolTip: "90 Days" }
	];

	ngOnInit() {
		// Use default only if parent didn't provide any
		if (!this.chipDurations || this.chipDurations.length === 0) {
			this.chipDurations = this.defaultDurations;
		}
	}

	ngOnChanges(changes: SimpleChanges) {
		// Optional: handle dynamic changes from parent
		if (changes['chipDurations'] && (!this.chipDurations || this.chipDurations.length === 0)) {
			this.chipDurations = this.defaultDurations;
		}
	}


	/**
	 * Update the selected Time
	 * @param newValue The newly selected time duration
	 */
	selectTime(newValue: string) {
		this.duration = newValue;
		this.durationChange.emit(newValue); // notify parent of change
	}
}
